import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.jsx';
import { huidigeTaal, zetThema, bewaardThema } from './i18n.js';
import './stijl.css';

/* Bij een 4xx heeft nog eens proberen geen zin; dan wil je de fout zien. Zoals in ADTS-ONE. */
const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (aantal, fout) => (fout?.status >= 400 && fout?.status < 500 ? false : aantal < 1),
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

document.documentElement.lang = huidigeTaal();
/* Vóór het eerste scherm, anders flitst het verkeerde thema langs. Wat de server zegt wint daarna. */
zetThema(bewaardThema());

createRoot(document.getElementById('app')).render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
